  
class Locations {
  
  constructor($rootScope, $location, Utils, Survey){
    
    this.Survey = Survey;
    this.$location = $location;
    this.Utils = Utils;

    this.manualHref = $rootScope.manualHref;
  }

  onChooseLocation(location) {

    if (location) {
      this.Survey.setPhysicalLocation(location);
    }

    this.$location.path('/intake');
  }

  $onInit() {
    this.locations = this.Survey.getSchool().locations || [];
  }
}

Locations.$inject = ['$rootScope', '$location', 'Utils', 'Survey'];

module.exports = {
  template: require('./locations.html'),
  controllerAs: 'ctrl',
  controller: Locations
};